import React, { Component } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'

import Recommend from './Recommend'


const DEFAULT_COLLAPSED_ITEMS = 4

class RecentTasks extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expand: false,
    }
  }

  render() {
    let tasks = this.props.tasks || []
    if (!this.state.expand) {
      tasks = tasks.slice(0, DEFAULT_COLLAPSED_ITEMS)
    }
    return <div>
      {this.props.tasks && this.props.tasks.length === 0 && <div>
          実施したタスクはありません
        </div>}
      {this.props.tasks && this.props.tasks.length > 0 &&
        <Container>
          <Row className='h-100'>
            {tasks.map(task =>
              <Col md='6'>
                <Recommend
                  key={task.id}
                  type='cloze'
                  baseURL={this.props.baseURL}
                  progress={true}
                  item={task}
                  imgsrc={(this.props.images || {})[task.id]}
                />
              </Col>)}
          </Row>
          {this.props.tasks && this.props.tasks.length > DEFAULT_COLLAPSED_ITEMS && <Row>
              <Col sm='12'>
                <Button
                  variant='link'
                  className='ItemsExpand'
                  onClick={() => this.setState({ expand: !this.state.expand })}
                >
                  <FontAwesomeIcon icon={this.state.expand ? faAngleUp : faAngleDown} />
                  &nbsp;{this.state.expand ? '閉じる' : 'さらに確認'}
                </Button>
              </Col>
            </Row>}
        </Container>}
    </div>
  }
}

export default RecentTasks;
